import React, { PureComponent } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

/**
 * for this page
 */
const Footer = errorBoundary(
    class extends PureComponent {
        render() {
            return (
                <div id="footer" className={styles.footer}>
                    <div className={`${styles.footlink} clearfix`}>
                        <div className={styles.fk_l}>
                            <a className={styles.nolpad} href="//www.ifeng.com/corp/about/intro/" target="_blank">
                                凤凰新媒体介绍
                            </a>
                            <a href="http://ir.ifeng.com/" target="_blank">
                                投资者关系 Investor Relations
                            </a>
                            <a href="http://biz.ifeng.com/" target="_blank">
                                广告服务
                            </a>
                            <a href="//career.ifeng.com/" target="_blank">
                                诚征英才
                            </a>
                            <a href="http://www.ifeng.com/corp/privacy/" target="_blank">
                                保护隐私权
                            </a>
                            <a href="http://www.ifeng.com/corp/exemption/" target="_blank">
                                免责条款
                            </a>
                            <a href="http://www.ifeng.com/corp/feedback/" target="_blank">
                                意见反馈
                            </a>
                            <a href="http://phtv.ifeng.com/intro/" target="_blank" className={styleMedia.noborder}>
                                凤凰卫视介绍
                            </a>
                        </div>
                        <div className={styles.fk_r}>
                            <ul>
                                <li className={styles.l_bg001}>
                                    <a href="https://v.ifeng.com/" target="_blank" title="视频">
                                        视频
                                    </a>
                                </li>
                                <li>
                                    ·<a href="https://news.ifeng.com/" target="_blank" title="资讯">
                                        资讯
                                    </a>
                                </li>
                                <li>
                                    ·<a href="https://zhibo.ifeng.com/?_cpb_fzb_6" target="_blank" title="直播">
                                        直播
                                    </a>
                                </li>
                                <li className={styles.l_bg002}>
                                    <a href="https://www.ifeng.com/" target="_blank" title="凤凰网">
                                        凤凰网
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className={styles.copyright}>
                        <span>凤凰新媒体</span>
                        <span>版权所有</span>
                        <span>Copyright © 2019 Phoenix New Media Limited All Rights Reserved.</span>
                    </div>
                </div>
            );
        }
    },
);

export { Footer };
export default Footer;
